<template>
    <div id="gameList" ref="gameList">
        <headerPage :title="title" :iconSrc='iconSrc' :headerSty='headerSty'></headerPage>
        <headerBg :headerBg="headerBg" class="headerBg"></headerBg>
        <div class="list">
            <div v-for="(item,index) in gameList" :key="index">
                <div class="gameImg">
                    <img :src="item.gamerskyGameCover" alt="">
                    <div class="icon" v-if="item.freeGot">
                        已白嫖
                    </div>
                </div>
                <div class="gameName">{{item.gamerskyGameName}}</div>
            </div>
            
        </div>
        <!-- <div class="btn">
            <div class="shareBtn">分享我的EPIC年度总结！</div>
        </div> -->
        
        
    </div>
</template>

<script>
import headerPage from '../../components/header.vue'
import headerBg from '../../components/headerBg.vue'
export default {
    props:{
        data:{
            type:[Object]
        }
    },
    data(){
        return{
            title:'2022白嫖游戏单',
            iconSrc:require('../../assets/image/'+this.$route.query.type+'/'+this.$route.query.type+'_small.png'),
            headerSty:{
                padding:'4.2rem 0 0 1.95rem',
                // 'margin-top':'2100px',
            },
             headerBg:{
                height:'12.45rem',
                background: 'url('+require('../../assets/image/steam/headerBg.png')+')',
                backgroundRepeat:'no-repeat',
                backgroundSize:'300%',
                backgroundPosition: '8% 15%',
                // backgroundAttachment: 'fixed',
            },
           

            gameList:[],
        }
    },
    mounted(){
        this.gameList=this.data.gameList
       
        
      
        // let that = this;
        // that.$emit("getNoSwiping",false)
        // window.addEventListener(
        //     "scroll",
        //     function(e) {
        //         console.log(e.target.scrollTop);
        //         if(e.target.scrollTop==0){
        //             that.$emit("getNoSwiping",false)
        //         }

        //     },
        //     true
        // );
      


    },
    components:{
        headerPage,
        headerBg
    }
}
</script>

<style>
#gameList {
    padding-bottom: 50px;
}
#gameList .list{
    padding: 0 1.9rem 2rem;
    margin-top: 1.25rem;

}
#gameList .list{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
#gameList .list>div{
    /* margin: 0 0.8rem 0.75rem 0; */
    text-align: center;
}
#gameList .list .gameName{
    /* margin-bottom: 0.4rem; */
    max-width: 7.45rem;
    margin: 0.4rem 0 0.75rem 0;
    color: #fff;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
#gameList .list .gameImg{
    width: 7.45rem;
    height: 4rem;
    position: relative;
}
#gameList .list .gameImg img{
    object-fit: cover;
}

#gameList .list .gameImg .icon{
    width: 2.65rem;
    height: 1.28rem;
    border-radius: 0.4rem;
    font-size: 0.6rem;
    background: #FF5E5E;
    color: #fff;
    position: absolute;
    top: 0;
    left: 0;
    text-align: center;
    line-height: 1.28rem;
    transform: scale(0.66);
}

#gameList .btn{
  
}
#gameList .shareBtn{
    width: 14.9rem;
    height: 1.75rem;
    background: linear-gradient(90deg, #FF7777, #ED4343);
    border-radius: 0.85rem;
    margin: 0 auto;
    font-size: 0.6rem;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 1.75rem;
    text-align: center;
  
}
</style>